import React from 'react';
import StatsTabs from './StatsTabs';
import StatsCards from './StatsCards';
import Footer from '../JobPage/Footer';
import { JobSeekerSection } from './JobSeekerSection';
import Header from '../JobPage/Header';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';

export default function TechStatsPage() {
  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col items-center justify-center py-7 px-20">
      <Container size="default" className="w-full max-w-[1214px] flex flex-col">
        <Header />
        <StatsTabs />
        <StatsCards />
        <JobSeekerSection />
        <Footer />
      </Container>
    </div>
  );
}
